export const phoneValidatorRegExp = /^[+]?[\s\d]*[(]?\d{1,4}[)]?[-\s./\d]*$/;

const validatePhone = (string: string): boolean => phoneValidatorRegExp.test(string);

export default validatePhone;
